
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import check from "../../img/check.png";
import sf1 from "../../img/sf1.png";
import sf2 from "../../img/sf2.png";
import sf3 from "../../img/sf3.png";
import sf4 from "../../img/sf4.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const BASE_URL = "https://akk.net.in:4000";
const ZOHO_URL = "https://crm.zoho.in/crm/WebToLeadForm";

const ZOHO_XNQSJSDP =
  "1901f3e071f2cd4306379fe60f26367897ab16e7e03baafef8f96f5cb13db681";

const ZOHO_XMIWTLD =
  "ff07abcb72d4567c208000f5a2ee1cb78014d33bd5105db69ad54e87901a128278ae2864ffc1d1f4ebb2a9028d2b90c8";

const ZOHO_ANALYTICS_URL =
  "https://crm.zohopublic.in/crm/WebFormAnalyticsServeServlet?rid=500542ba406403b48eb28e59be357d7232a7fa0898b2f7dc04b84d5ca3c55be994dd85e25296580c4aece87a13eb1d3cgid767218197e92fc67eeae843998cd8e631dbac0bff47d11cc4cb11cc6febc6369gid1193e034af6c50b9407643e91ff658949662c44fa39413161dd789be313cd2ecgidca530b0226b7c47fb85be4c3b2ec27414f2aedca7003ad43df06481f25f25b61&tw=65088a595584bc9b83f2b807ff835dce8034892ad10d1e08ff8756dee78ad287&version=v2";

const INITIAL_FORM = {
  name: "",
  email: "",
  phoneNo: "",
  vehicleRegNo: "",
  vehicleLocation: "",
  otp: "",
};

const benefits = [
  "Government Authorized",
  "Hassle Free",
  "Instant Payment",
  "Environmentally Friendly",
  "Any Conditions of Vehicles",
];

const steps = [
  {
    image: sf1,
    title: "Free car assessment",
    description: "Share your car photos & RC - Get instant evaluation.",
  },
  {
    image: sf2,
    title: "Instant Payment",
    description: "We'll pay you first and then transport your ELV to our factory.",
  },
  {
    image: sf3,
    title: "Get Certificate of Deposit (CoD)",
    description:
      "Get incentive up to 25% of Motor vehicle tax & get your vehicle deregistered (piece of mind!)",
  },
  {
    image: sf4,
    title: "Free vehicle pickup",
    description: "Get your vehicle picked up as per your convenience",
  },
];

export default function SellCarPage() {
  const [showOTP, setShowOTP] = useState(false);
  const [checkOutClicked, setCheckOutClicked] = useState(false);
  const [renderqna, setRenderqna] = useState([]);
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [page, setPage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Existing on-screen number verification
  const verificationNumber = useRef(Math.floor(Math.random() * 100) + 1);
  const zohoFormRef = useRef(null);

  const currentURL = window.location.href;
  const successURL = `${window.location.origin}/success`;

  const smarturl =
    new URLSearchParams(window.location.search).get("service") === "smarturl";

  // Fetch Sell Car page content and FAQs
  useEffect(() => {
    let cancelled = false;

    const fetchPageData = async () => {
      try {
        const [categoriesResponse, faqResponse, pageResponse] =
          await Promise.all([
            fetch(`${BASE_URL}/faq/getfaqCategories`),
            fetch(`${BASE_URL}/faq/getFaq`),
            fetch(`${BASE_URL}/sellcarPage/getsellcarpage`, {
              method: "POST",
            }),
          ]);

        if (
          !categoriesResponse.ok ||
          !faqResponse.ok ||
          !pageResponse.ok
        ) {
          throw new Error("Unable to load Sell Car page information");
        }

        const [categoriesResult, faqResult, pageResult] =
          await Promise.all([
            categoriesResponse.json(),
            faqResponse.json(),
            pageResponse.json(),
          ]);

        if (cancelled) return;

        const category = (categoriesResult.faq || []).find(
          (item) => item.name === "sellcar"
        );

        const matchingFaq = (faqResult.faq || []).find(
          (item) => item.categoryId === category?._id
        );

        setRenderqna(matchingFaq?.faq || []);
        setPage(pageResult.data || null);
      } catch (error) {
        console.error("Sell Car page load failed:", error);
      }
    };

    fetchPageData();
    window.scrollTo(0, 0);

    return () => {
      cancelled = true;
    };
  }, []);

  // Load Zoho Web-to-Lead analytics
  useEffect(() => {
    window._wFa_ajax_will_be_replaced = false;
    window._wfa_fstprtcken = window._wfa_fstprtcken || {};
    window._wfa_fstprtcken["1320227000001000194"] = true;

    const script = document.createElement("script");

    script.src = ZOHO_ANALYTICS_URL;
    script.async = true;
    script.id = "wf_anal";

    document.body.appendChild(script);

    return () => script.remove();
  }, []);

  // Validate existing Sell Car fields
  const handleVerifyClick = () => {
    const {
      name,
      email,
      phoneNo,
      vehicleRegNo,
      vehicleLocation,
    } = formData;

    if (
      !name.trim() ||
      !email.trim() ||
      !phoneNo.trim() ||
      !vehicleRegNo.trim() ||
      !vehicleLocation.trim()
    ) {
      alert("Please fill in all fields.");
      return;
    }

    if (!/^\d{9,10}$/.test(phoneNo.trim())) {
      alert("Please enter a contact number with 9 to 10 digits.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!/^[a-zA-Z0-9]{5,12}$/.test(vehicleRegNo.trim())) {
      alert(
        "Vehicle registration number must be alphanumeric (5-12 characters)."
      );
      return;
    }

    if (!checkOutClicked) {
      alert("Please agree to the website Privacy Policy.");
      return;
    }

    setShowOTP(true);
  };

  // Submit to the existing API, then Zoho CRM
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    if (formData.otp.trim() !== String(verificationNumber.current)) {
      alert("Type the correct number");
      return;
    }

    setIsSubmitting(true);

    try {
      // Step 1: Existing Sell Car inquiry API
      const response = await fetch(`${BASE_URL}/inquiry/sellCar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(
          `Sell Car API returned HTTP ${response.status}`
        );
      }

      const result = await response.json();

      if (
        result?.success === false ||
        result?.success === 0 ||
        result?.success === "0"
      ) {
        throw new Error(
          result?.message || "Inquiry was not accepted"
        );
      }

      // Step 2: Submit lead to Zoho CRM
      // Native form submission avoids browser CORS restrictions.
      if (!zohoFormRef.current) {
        throw new Error("Zoho form is unavailable");
      }

      zohoFormRef.current.submit();
    } catch (error) {
      console.error("Sell Car enquiry failed:", error);
      alert("Unable to submit your inquiry. Please try again.");
      setIsSubmitting(false);
    }
  };

  const updateField = (field) => (event) => {
    setFormData((previous) => ({
      ...previous,
      [field]: event.target.value,
    }));
  };

  const youtubeURL =
    page?.youTube ||
    "https://www.youtube.com/embed/DWHoXy5eu9U?si=PpwSBrDBxn8yraO3";

  return (
    <div>
      <Helmet>
        <title>{page?.metaTitle || "Sell Your Car"}</title>

        <meta
          name="description"
          content={page?.metaDescription || ""}
        />

        <meta
          name="keywords"
          content={page?.metaKeyword || ""}
        />

        <link rel="canonical" href={currentURL} />
      </Helmet>

      <Navbar />

      {/* Banner and existing quote form */}
      <div
        className="heading_banner_auto sell_car_banner"
        style={{
          backgroundImage: `url(${page?.bannerImage || ""})`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-4">
              <ul className="sell_car_banner_info">
                {benefits.map((benefit) => (
                  <li key={benefit}>
                    <img
                      src={check}
                      loading="lazy"
                      width="20"
                      height="20"
                      alt=""
                    />
                    <p>{benefit}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-6 col-md-8">
              <div
                className="sell_car_banner_holder"
                id="sell-car-form"
              >
                <h1 className="text-center">
                  Get Instant Quote.
                </h1>

                <form onSubmit={handleSubmit}>
                  {!showOTP && (
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="sell-name"
                            placeholder="Enter Your Name"
                            value={formData.name}
                            onChange={updateField("name")}
                            required
                          />
                          <label htmlFor="sell-name">
                            Your Name
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            id="sell-email"
                            placeholder="Enter Your Email ID"
                            value={formData.email}
                            onChange={updateField("email")}
                            required
                          />
                          <label htmlFor="sell-email">
                            Your Email ID
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="tel"
                            className="form-control"
                            id="sell-phone"
                            placeholder="Your Contact Number"
                            value={formData.phoneNo}
                            onChange={updateField("phoneNo")}
                            required
                          />
                          <label htmlFor="sell-phone">
                            Contact Number
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="sell-reg"
                            placeholder="Vehicle Registration Number"
                            value={formData.vehicleRegNo}
                            onChange={updateField("vehicleRegNo")}
                            required
                          />
                          <label htmlFor="sell-reg">
                            Vehicle Registration Number
                          </label>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="sell-location"
                            placeholder="Enter Vehicle Location"
                            value={formData.vehicleLocation}
                            onChange={updateField("vehicleLocation")}
                            required
                          />
                          <label htmlFor="sell-location">
                            Vehicle Location
                          </label>
                        </div>
                      </div>

                      <div className="col">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="gridCheck"
                            checked={checkOutClicked}
                            onChange={(event) =>
                              setCheckOutClicked(
                                event.target.checked
                              )
                            }
                            required
                          />

                          <label
                            className="form-check-label"
                            htmlFor="gridCheck"
                          >
                            By clicking, I agree to the website
                            Privacy Policy.
                          </label>
                        </div>
                      </div>
                    </div>
                  )}

                  {showOTP && (
                    <div className="row g-3">
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        By continue, I agree to share my
                        personal information and I consent to
                        being contacted based on the
                        information provided.
                      </p>

                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "blue",
                        }}
                      >
                        Enter the number{" "}
                        {verificationNumber.current}
                      </p>

                      <div className="col">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="sell-otp"
                            placeholder="Enter OTP"
                            value={formData.otp}
                            onChange={updateField("otp")}
                            required
                          />
                          <label htmlFor="sell-otp">
                            Enter above number here..
                          </label>
                        </div>
                      </div>

                      <div className="d-grid gap-2 col-lg-4 col-md-5 col-sm-6 col-xs-8 mx-auto">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting
                            ? "Submitting..."
                            : "Submit"}
                        </button>
                      </div>
                    </div>
                  )}

                  {!showOTP && (
                    <div className="d-grid gap-2 col-lg-4 col-md-5 col-sm-6 col-xs-8 mx-auto">
                      <button
                        className="btn btn-primary"
                        style={{
                          border: "1px solid transparent",
                        }}
                        type="button"
                        onClick={handleVerifyClick}
                      >
                        Verify
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Section */}
      <div className="sell_car_feature">
        <div className="container">
          <h2 className="a5 pd2 text-center">
            Scrap your car made easy with AKK
          </h2>

          <div className="row">
            {steps.map((step, index) => (
              <div
                className="col-md-3 col-sm-4 col-xs-12"
                key={step.title}
              >
                <div className="sell_car_feature_ft">
                  <img
                    src={step.image}
                    loading="lazy"
                    height="60"
                    width="auto"
                    alt="Scrap your car with AKK"
                  />

                  <div className="rank">
                    <span>{index + 1}</span>
                  </div>

                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why AKK Section */}
      <div className="container">
        <div className="featured_box">
          <div className="row">
            <div className="col-lg-7 col-md-8 col-sm-12 d-md-none d-block">
              <iframe
                width="100%"
                height="300"
                src={youtubeURL}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            <div className="col-lg-5 col-md-4 col-sm-12">
              <h3 className="a5">Why AKK?</h3>

              <ul className="featured_list">
                {benefits.map((benefit) => (
                  <li key={benefit}>
                    <img
                      src={check}
                      loading="lazy"
                      width="20"
                      height="20"
                      alt=""
                    />
                    <p>{benefit}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-7 col-md-8 col-sm-12 d-none d-md-block">
              <iframe
                width="100%"
                height="400"
                src={youtubeURL}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          <div className="d-grid gap-2 col-lg-4 col-md-5 col-sm-6 col-xs-8 mx-auto">
            <a
              className="btn btn-primary btn-lg"
              href="#sell-car-form"
              style={{
                marginTop: "3rem",
                border: "1px solid transparent",
              }}
            >
              Get Instant Web Quote
            </a>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg4">
        <div className="container">
          <h4 className="a5 text-center">
            FAQs about Selling Cars
          </h4>

          <div className="row">
            <div
              className="accordion accordion_faq accordion-flush"
              id="FAQ"
            >
              {renderqna.length > 0
                ? renderqna.map((item, index) => {
                    const faqId = `faq_${index}`;

                    return (
                      <div
                        className="accordion-item"
                        key={faqId}
                      >
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${faqId}`}
                            aria-expanded="false"
                            aria-controls={faqId}
                          >
                            {item.ques}
                          </button>
                        </h2>

                        <div
                          id={faqId}
                          className="accordion-collapse collapse"
                          data-bs-parent="#FAQ"
                        >
                          <div className="accordion-body">
                            {item.ans}
                          </div>
                        </div>
                      </div>
                    );
                  })
                : "No FAQs available."}
            </div>
          </div>
        </div>
      </div>

      {/* Zoho CRM Vehicle Procurement Form */}
      {/* Hidden: existing visible form supplies its values */}
      <form
        ref={zohoFormRef}
        id="webform1320227000001000194"
        name="WebToLeads1320227000001000194"
        action={ZOHO_URL}
        method="POST"
        acceptCharset="UTF-8"
        style={{ display: "none" }}
      >
        <input
          type="hidden"
          name="xnQsjsdp"
          value={ZOHO_XNQSJSDP}
          readOnly
        />

        <input
          type="hidden"
          name="zc_gad"
          id="zc_gad"
          value=""
          readOnly
        />

        <input
          type="hidden"
          name="xmIwtLD"
          value={ZOHO_XMIWTLD}
          readOnly
        />

        <input
          type="hidden"
          name="actionType"
          value="TGVhZHM="
          readOnly
        />

        <input
          type="hidden"
          name="returnURL"
          value={successURL}
          readOnly
        />

        <input
          type="hidden"
          name="aG9uZXlwb3Q"
          value=""
          readOnly
        />

        <input
          type="hidden"
          name="Last Name"
          value={formData.name}
          readOnly
        />

        <input
          type="hidden"
          name="Email"
          value={formData.email}
          readOnly
        />

        <input
          type="hidden"
          name="Mobile"
          value={formData.phoneNo}
          readOnly
        />

        <input
          type="hidden"
          name="LEADCF5"
          value={formData.vehicleRegNo}
          readOnly
        />

        <input
          type="hidden"
          name="Description"
          value={formData.vehicleLocation}
          readOnly
        />

        {smarturl && (
          <input
            type="hidden"
            name="service"
            value="smarturl"
            readOnly
          />
        )}
      </form>

      <Footer />
    </div>
  );
}
